import * as encodedTables from "./tables-prod.js";

// Decode all Base64 tables at startup
const tables = {};
for (const [key, value] of Object.entries(encodedTables)) {
  // Remove the "Encoded" suffix to match old variable names
  const plainName = key.replace(/Encoded$/, "");
  tables[plainName] = JSON.parse(atob(value));
}

// Export each table with its original name
export const {
  containerTable,
  coolStuffTable,
  tubularStuffTable,
  petTable,
  instrumentTable,
  pizzaTable,
  quirksTable,
  physicalDistinctionsTable,
  obsessionsTable,
  stylesTable,
  dayJobsTable,
  dayJobsItemsTable,
  armorTable,
  weaponTable,
  firstNamesTable,
  nicknameTable,
  lastNameTable,
  statLookupTable,
  classTable,
  classAbilityTables,
  classDescriptionTable,
  classStatsModifierTable,
  classHpTable,
  classLuckDieTable,
  classArmorTable,
  classWeaponTable,
  animalFormsTable,
  plotHookTable,
  burroughTable,
  enemyTypeTable,
  enemyMotivationTable,
  enemyArmorTable,
  enemyHPTable,
  enemyAttackTable,
  enemyMoraleTable,
  enemySpecialTable,
  oddLootTable,
  randomCityEncounterTable,
  weatherTable
} = tables;